export const profileKeys = [
  'phoneNumber',
  'companyName',
  'companyUrl',
  'companyAddress',
  'companyCity',
  'companyState',
  'companyZipCode',
  'companyCountry',
  'useCase',
  'isReferred',
  'referredBy',
  'earlyAdopterProgram'
];



// WEBPACK FOOTER //
// ./src/client/modules/user/constants.js